import ChartDatasets from "./datasets/dataset_helper"
import ChartOptions from "./options/options"
export default {
    name: "EmailsChartComponent",
    datasets: [],
    labels: ['yahoo.it','hotmail.it','gmail.com','hotmail.com'],
    loading: true,
    style:"height: 150px",
    datasets: [{
        data: [0, 0, 0, 0],
        fill: true,
        backgroundColor: [
            'rgba(162, 10, 234)',
            'rgba(10, 108, 234)',
            'rgb(231, 13, 13)',
            'rgba(98, 99, 131)',
        ],
        borderWidth:1,
        borderRadius:2,
        hoverOffset:4
    }],
    options: {
        legend:{
            display: true,
            labels: {
                fontColor: 'rgb(255, 255, 255)'
            }
        }
    }
}